import React, { lazy, Suspense, useEffect, useState } from "react";
import { useTestContext } from "../context/TestContext";
import { useParams } from "react-router-dom";

// imports
import UIWrapper from "../components/UIWrapper";
import NavigationTracker from "../components/NavigationTracker";
import NavigationBar from "../components/NavigationBar";
import Pagination from "../components/Pagination";
const ProductCard = lazy(() => import("../components/ProductCard"));

const navigationLinks = [
  { title: "Blood", link: "/risk-based-testing/Blood" },
  { title: "Liver", link: "/risk-based-testing/Liver" },
  { title: "Heart", link: "/risk-based-testing/Heart" },
  { title: "Kidney", link: "/risk-based-testing/Kidney" },
  { title: "Bones", link: "/risk-based-testing/Bones" },
];

const RiskBasedTesting = () => {
  const { fetchFilteredProducts, filteredProducts, filterPaginationInfo } =
    useTestContext();
  const { filterData } = useParams();
  const [currentPage, setCurrentPage] = useState(1);

  // Scroll to top with smooth behavior when filterData changes (or on initial mount)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [filterData]);

  useEffect(() => {
    fetchFilteredProducts(filterData, currentPage);
  }, [filterData, currentPage]);

  return (
    <UIWrapper>
      <div className="w-full h-fit p-[3%] lg:p-[2%]">
        <NavigationTracker endpoint="Risk-Based Testing" />
        <div className="w-full h-fit flex justify-center items-center px-[2%] lg:px-[25%] mb-[10%]">
          <NavigationBar navigationLinks={navigationLinks} />
        </div>
        <div className="w-full h-fit grid grid-cols-1 lg:grid-cols-3 gap-x-0 gap-y-3 lg:gap-y-14 mx-auto justify-items-center px-[5%] mb-[3%]">
          <Suspense
            fallback={
              <div className="w-full h-fit flex justify-center items-center">
                <p className="font-normal text-[1vw] text-textSecondaryColor">
                  Loading products...
                </p>
              </div>
            }
          >
            {filteredProducts?.map((item, index) => (
              <ProductCard key={index} data={item} />
            ))}
          </Suspense>
        </div>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={filterPaginationInfo?.totalPages}
        />
      </div>
    </UIWrapper>
  );
};

export default RiskBasedTesting;
